module.exports = __webpack_public_path__ + "img/admin-settings-male.f39b0118.png";